module.exports = __webpack_public_path__ + "static/media/elan3.42ff875c.jpg";